export default __webpack_public_path__ + "static/media/dictionary_rgb(234,234,237).1c087bd4.svg";